<template>
  <div>
    <div class="container bg-gray">
      <div class="row">
        <div class="col-12">
         <b-form-group label="Individual inline checkboxes">
            <b-form-checkbox
              v-for="option in choices"
              v-model="selected"
              :key="option.value"
              :value="option.value"
              inline
            >
              {{ option.text }}
            </b-form-checkbox>
          </b-form-group>
        </div>
          
        <div class="col-12 mb-2 text-center">
          <b-button :disabled="is_disabled"  class="next py-2 px-4" @click="next()" > {{$t("message.show_ans")}}→ </b-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'; 
export default {
  props:{
    choices: {},
    id: undefined,
    gt: undefined,
  },
  data () {
    return {
      selected: [],
      is_disabled: false
    }
  },
  methods: {
    next(){
      this.is_disabled = true
      if(this.id == undefined){
        this.$emit('setAnswer', this.selected)
      }else{
        this.$emit('setSample', this.selected, this.id)
      }
      
    }
  },
  mounted(){
    if(this.gt != undefined){
      this.selected = this.gt
    }
  },
  computed: {
    ...mapState({
        memberInfo: state => state.user.user
    })
  },

}
</script>

<style scoped lang="scss">
.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}

</style>
